import React, { FC } from 'react';
import clsx from 'clsx';
import styles from './InputButton.module.css';

const InputButton: FC<{
  disabled: boolean;
  onClick: () => void;
}> = ({ disabled, onClick }) => (
  <button
    className={clsx({
      [styles.button]: true,
      [styles.disabled]: disabled,
    })}
    disabled={disabled}
    onClick={(): void => {
      if (onClick && !disabled) onClick();
    }}
    onTouchEnd={(e): void => {
      // this stops the mobile keyboard (at least on ios) from
      // automatically hiding itself after a message is sent.
      e.preventDefault();
      if (onClick && !disabled) onClick();
    }}
    type="button"
  >
    <svg
      role="img"
      className={styles.svg}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 15.8333V4.16663"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16675 9.99996L10.0001 4.16663L15.8334 9.99996"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);

export default InputButton;
